import React from 'react';
import DemoFrame from './DemoFrame';
import useDemoPlayer, { useStepCount } from './useDemoPlayer';
import HwpDocPane, { HWP_DEMO_FORM_CELLS } from './HwpDocPane';

const FILL_TICK_MS = 260;

// 0 양식 열림 → 1 칸 채우기 → 2(완성) 저장 버튼 활성
const STEPS = [1000, HWP_DEMO_FORM_CELLS.length * FILL_TICK_MS + 500];

const HwpFormDemo = ({ surface = 'home', title = 'AI 한글', autoStart = false }) => {
  const player = useDemoPlayer({ steps: STEPS, surface, feature: 'hwp', autoStart });
  const { phase, done, paused } = player;
  const filledCount = useStepCount(HWP_DEMO_FORM_CELLS.length, { active: phase === 1, complete: phase > 1, paused, tickMs: FILL_TICK_MS });

  return (
    <DemoFrame title={title} player={player} className="wqdemo-hwp">
      <HwpDocPane filledCount={filledCount} filling={phase === 1} done={done} />
    </DemoFrame>
  );
};

export default HwpFormDemo;
